import { useState } from 'react'
import { Copy } from '../Copy'
import CodePre from './CodePre'
import { ICodeProps } from './types'
import styles from './styles.module.scss'
import { ShowHide } from '../ShowHide'
import clsx from 'clsx'

const Code = ({
  code,
  defaultIsOpen = true,
  transparent = false,
  language = 'json',
  hasReveal = true,
  onCopy,
  onReveal,
}: ICodeProps) => {
  const [openState, setOpenState] = useState<boolean>(defaultIsOpen)

  // This is a simple solution for missing cURL in Prism, the format still looks good and readable, and the Code title is cURL
  const languageFormatted = language === 'cURL' ? 'shell' : language

  return (
    <section
      className={clsx(styles.wrap, {
        [styles.transparent]: transparent,
        [styles.isOpen]: openState,
      })}
    >
      <header
        className={clsx(styles.header, {
          [styles.isOpen]: openState,
        })}
      >
        {language.toLocaleUpperCase()}
        <div className={styles.buttons}>
          <Copy text={code} onCopy={onCopy} />
          {hasReveal && (
            <ShowHide
              onChange={(isShowHideOpen) => (onReveal ? onReveal() : setOpenState(isShowHideOpen))}
              isOpen={openState}
            />
          )}
        </div>
      </header>
      <CodePre code={code} language={languageFormatted} defaultIsOpen={openState} />
    </section>
  )
}

export default Code
